// eslint-disable-next-line no-use-before-define
var generic = generic || {};

(function ($) {
  function initNotifyMe() {
    var serviceBus = window.GlobalServiceBus;
    var serviceBusTopics = window.ServiceBusTopics;

    if (!serviceBus || !serviceBus.emit || !serviceBusTopics || !serviceBusTopics.events) {
      return;
    }

    $(document).on('perlgem.notify_me', function (e, payload) {
      var params;
      var responsePayload;
      var serviceEvents;

      if (!payload || !payload.skuId || !payload.skuBaseId || !payload.email) {
        return false;
      }

      params = {
        _SUBMIT: 'bis_notification',
        EMAIL_ADDRESS: payload.email,
        EVENT_NAME: 'BIS',
        REQUEST_TYPE: 'BIS',
        SKU_BASE_ID: payload.skuBaseId
      };
      responsePayload = { skuId: payload.skuId };
      serviceEvents = serviceBusTopics.events;

      generic.jsonrpc.fetch({
        method: 'form.get',
        params: [params],
        onSuccess: function () {
          if (serviceEvents.PRODUCT_NOTIFY_ME_REQUEST_SUCCESS) {
            serviceBus.emit(serviceEvents.PRODUCT_NOTIFY_ME_REQUEST_SUCCESS, responsePayload);
          }
        },
        onFailure: function () {
          if (serviceEvents.PRODUCT_NOTIFY_ME_REQUEST_FAILURE) {
            serviceBus.emit(serviceEvents.PRODUCT_NOTIFY_ME_REQUEST_FAILURE, responsePayload);
          }
        },
        onError: function () {
          if (serviceEvents.PRODUCT_NOTIFY_ME_REQUEST_FAILURE) {
            serviceBus.emit(serviceEvents.PRODUCT_NOTIFY_ME_REQUEST_FAILURE, responsePayload);
          }
        }
      });
    });
  };

  function waitForServiceBus(callback) {
    var isServiceBusValid = window.GlobalServiceBus && window.GlobalServiceBus.emit;
    var isServiceBusTopicsValid = window.ServiceBusTopics && window.ServiceBusTopics.events;

    if (isServiceBusValid && isServiceBusTopicsValid) {
      callback();
    } else {
      setTimeout(function () {
        waitForServiceBus(callback);
      }, 50);
    }
  }

  $(document).ready(function () {
    waitForServiceBus(initNotifyMe);
  });
})(jQuery);
